'use strict'
module.exports = require('./calendar')



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/